import React from 'react'
import { Spin } from 'antd'
import './styles.scss'

/**
 * @Dev
 * @param {@} className
 * @param {@} size small |standard | larger
 */

const ButtonSecondary = ({ className, size, disabled, loading, arrow, hoverAble, onClick, children, ...props }) => (
  <button
    className={`button-secondary ${className}`}
    type="button"
    disabled={disabled}
    data-size={size ? size.toString() : 'standard'}
    data-loading={loading.toString()}
    data-hoverable={hoverAble.toString()}
    onClick={() => {
      if (!loading && !disabled) {
        onClick()
      }
    }}
    {...props}
  >
    <div>
      <span>
        {children}
        {arrow}
      </span>
    </div>

    <Spin spinning={loading} />
  </button>
)

ButtonSecondary.defaultProps = {
  className: '',
  arrow: '',
  disabled: false,
  loading: false,
  hoverAble: true,
  onClick: () => null,
}

export default ButtonSecondary
